import useUserPermission from "~/hooks/useUserPermission";
import { ADMIN_AGENTS } from "~/router/permissions";

// The `admin:agents` functional scope bypasses the per-object FGA axis on the
// backend (see `authorize_capability`), so an admin can exercise every agent
// capability regardless of their resolved `access_level`. Capability hooks OR this
// in to mirror that bypass, keeping the UI in step with what the API permits.
export const useCanAdministerAIAgents = (): boolean => useUserPermission(ADMIN_AGENTS);
